/**
 * 「右侧子页」面板（`#panel-ext`）的公共件（2026-10-12 · P5.5-5）。
 *
 * 这个面板**两种入口共用**：
 *  ① `#ext=` 外链（同源静态页，`router.js: showExtPanel`，地址经 `normalizeExtHref`）；
 *  ② 跨域嵌入（平台「尺码组」→ 分销那一套界面，`panels/dist-md-embed.js`，
 *     地址是后端现签的**绝对** URL，**不能**过 `normalizeExtHref`）。
 *
 * 差别只在「iframe 的地址从哪来」；外壳本身（隐藏别的面板、撑成一列、
 * 独占菜单激活态、组互斥展开、页标题、`mc:route` 事件）完全一样 —— 所以抽到这里，
 * 两边都调它。留在 `router.js` 里各写一份，早晚漂开：漂了的表现是
 * 「点菜单进去了但左侧没高亮」这种不报错、只在浏览器里看得见的毛病。
 */
import { $ } from "../lib/dom.js";
import { setExclusiveGroupOpen } from "../nav.js";

/** 路由变更广播。短剧模块靠它停轮询、商家状态条靠它复位 —— **换入口也必须发**。 */
export function emitRoute(route) {
  document.dispatchEvent(new CustomEvent("mc:route", { detail: { route } }));
}

export function setPageTitle(text) {
  const el = $("page-title");
  if (el) el.textContent = text || "商家控制台";
}

/** 菜单项显示名（＝页标题）。`#ext=` 面板与跨域嵌入面板都从侧栏那一项取。 */
export function moduleTitleFromNav(link) {
  if (!link) return "";
  return (link.textContent || "").trim();
}

/** 切到子页布局：只留 `#panel-ext` 可见，主区与列都收成 `--ext`。 */
export function revealExtShell() {
  document.querySelectorAll(".mcp-panel").forEach((p) => {
    p.classList.toggle("hidden", p.id !== "panel-ext");
  });
  const main = document.querySelector(".mc-main");
  if (main) main.classList.add("mc-main--ext");
  const col = document.querySelector(".mc-maincol");
  if (col) col.classList.add("mc-maincol--ext");
  document.querySelectorAll("#overview-drama-links a").forEach((a) => {
    a.classList.remove("active");
  });
}

/** 把 `#side-nav` 的激活态**独占**给 `el`（其余全部取消），并展开它所在的组。 */
export function markNavActive(el) {
  document.querySelectorAll("#side-nav a").forEach((a) => {
    a.classList.toggle("active", a === el);
  });
  if (!el) return;
  const sub = el.closest(".mcp-tree-subgroup");
  if (sub && !sub.classList.contains("open")) sub.classList.add("open");
  const group = el.closest(".mcp-tree-group");
  if (group) setExclusiveGroupOpen(group);
}

/** `#ext-notice`：子页顶部的一条说明条（跨域嵌入的失败态靠它，不靠白屏）。
 *
 * 两种面板共用同一个 `#panel-ext`，所以**切面板时必须清掉**上一条 —— 否则
 * 「尺码组打不开」的提示会一直挂在后面打开的别的外链页头上。
 */
export function setExtNotice(text) {
  const el = $("ext-notice");
  if (!el) return;
  el.textContent = text || "";
  el.classList.toggle("hidden", !text);
}

export function extFrame() {
  return $("ext-frame");
}
